import { createContext, ReactNode, useContext } from 'react';

import {
  CheckoutController,
  useCheckout,
} from '../features/checkout/hooks/useCheckout';
import { PrivateRoomQuery } from '../features/checkout/utils/privateRoomQuery';

type CheckoutProviderProps = {
  productShopifyId: string;
  children: ReactNode;
  initialFrameVariantId?: string | null;
  initialWorkIds?: string[];
  privateRoom?: PrivateRoomQuery | null;
  productSlug: string;
};

const CheckoutContext = createContext<CheckoutController | null>(null);

export const CheckoutProvider = ({
  children,
  initialFrameVariantId = null,
  initialWorkIds = [],
  privateRoom = null,
  productShopifyId,
  productSlug,
}: CheckoutProviderProps) => {
  const controller = useCheckout({
    initialFrameVariantId,
    initialWorkIds,
    privateRoom,
    productShopifyId,
    productSlug,
  });

  return (
    <CheckoutContext.Provider value={controller}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckoutCtx = (): CheckoutController => {
  const context = useContext(CheckoutContext);

  if (!context) {
    throw new Error('useCheckoutCtx must be used within a CheckoutProvider');
  }

  return context;
};
